<!--
 * @Author: your name
 * @Date: 2021-12-13 15:40:52
 * @LastEditTime: 2021-12-15 19:26:58
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \GeelyEmail_Mobile\src\components\listItem\index.vue
-->
<template>
	<van-swipe-cell>
		<div class="list-item" @click="handleClick">
			<!-- <div class="item-select" v-if="isMulti">
        <img src="../../assets/img/list-item-select.png" alt="" />
      </div> -->
			<div class="item-detail">
				<div class="item-user">
					<div class="user-img">
						<!-- <img src="" alt="" /> -->
						<span :style="userHeader === 'geely' ? 'font-size:12px' : ''">
							{{ userHeader }}
						</span>
					</div>
				</div>
				<div class="item-content">
					<div class="item-name">
						<span :class="[!item.IsRead ? 'item-read' : '']">
							<span v-if="[2, 3].includes(FolderType)"> {{ item.DisplayTo | DisplayTo }} </span>
							<span v-else>
								{{ item.Sender.Name || $t('home.recipients') }}
							</span>
						</span>
						<span>{{ item.DateTimeSent | timeFormat }}</span>
					</div>
					<div class="item-title" :style="!item.IsRead ? 'font-weight: bold' : ''">
						<span class="item-title-sub">{{ item.Subject || $t('home.subjectless') }}</span>
						<span v-if="item.HasAttachments"><i class="item-incon iconfont icon-fujian"></i></span>
					</div>
					<div class="item-subtitle" :style="{width: `${windowWidth - 100}px` }">
						<span>{{ item.Preview }}</span>
					</div>
				</div>
			</div>
		</div>
		<!-- <template #right>
			<div>
				<SwiperBtn type="no-read" />
				<SwiperBtn type="star" />
				<SwiperBtn type="delete" />
			</div>
		</template> -->
	</van-swipe-cell>
</template>

<script>
import utils from '../../utils'
import SwiperBtn from '../swipeBtn'
let that = null
export default {
	data() {
		return {}
	},
	components: {
		SwiperBtn
	},
	props: {
		/* 邮件数据 */
		item: {
			type: Object,
			default: () => {
				return {}
			}
		},
        windowWidth: {
			type: Number,
			default: 0
		},
		/* 是否多选 */
		isMulti: {
			type: Boolean,
			default: false
		},
		FolderType: {
			type: Number,
			default: 0
		}
	},
	created() {
		that = this
	},
	computed: {
		/* 用户头像 */
		userHeader() {
			if ([2, 3].includes(this.FolderType)) {
				if (this.item.DisplayTo && this.item.DisplayTo !== '') {
					return utils._mekaName(this.item.DisplayTo)
				} else {
					return 'geely'
				}
			} else {
				return utils._mekaName(this.item.Sender.Name)
			}
		}
	},
	methods: {
		/* 点击邮件 */
		handleClick() {
			console.log('点击邮件-----', this.item)
			let obj = { ...this.item }
			obj.IsRead = true
			this.$emit('clickEmaItem', obj)
			if (this.FolderType === 2) {
				this.$router.push({
					path: '/writemail',
					query: {
						mailid: this.item.Id,
						ftype: this.FolderType,
						etype: 4
					}
				})
			} else {
				this.$router.push({
					path: '/viewmail',
					query: {
						Id: this.item.Id,
						IsMeeting: this.item.IsMeeting,
						ftype: this.FolderType,
						AssociatedAppointmentId: this.item.AssociatedAppointmentId
					}
				})
			}
		}
	},
	filters: {
		timeFormat(e) {
			return utils._isToDayFormatter(e, utils._isDuringDate(e))
		},
		DisplayTo(e) {
			if (e && e !== '') {
				if (e.indexOf(';') > -1) {
					return e.split(';')[0]
				} else {
					return e
				}
			} else {
				return that.$t('home.recipients')
			}
		}
	}
}
</script>

<style lang="less" scoped>
.list-item {
	width: 100%;
	height: 45px;
	box-sizing: border-box;
	padding: 8px 8px 0 8px;
	overflow: hidden;
	display: flex;

	align-items: center;
	justify-content: space-between;
	.item-select {
		display: inline-block;
		width: 10px;
		height: 100%;
		margin-right: 8px;
		position: relative;
		img {
			position: relative;
			top: 4px;
			width: 10px;
			height: 10px;
		}
	}
	.item-detail {
		width: 100%;
		height: 100%;
		display: flex;
		// padding-bottom: 16px;
		align-items: center;
		justify-content: space-between;
		.item-user {
			width: 18px;
			height: 100%;
			margin-right: 5px;

			.user-img {
				width: 18px;
				height: 18px;
				line-height: 18px;
				text-align: center;
				background: #005de5;
				border-radius: 100%;
				span {
					color: #fff;
					font-size: 10px;
					font-weight: bold;
				}
				img {
					border-radius: 100%;
					width: 100% !important;
					height: 100% !important;
				}
			}
		}
		.item-content {
			flex: 1;
			height: 36px;
			border-bottom: 0.5px solid #ededed;
			// box-shadow: 0 1px #e5e5e5;
			.item-name,
			.item-title {
				display: flex;
				align-items: center;
				justify-content: space-between;
				color: #333;
			}
			.item-name {
				position: relative;
				font-size: 8px;
				line-height: 8px;
				margin-bottom: 4px;
				.item-read {
					font-weight: bold;
					margin-left: 9px;
				}
				.item-read::before {
					content: '';
					position: absolute;
					top: 25%;
					left: 0;
					margin-right: 4px;
					width: 4px;
					height: 4px;
					border-radius: 100%;
					background: #005de5;
				}
			}
			.item-name > span:last-child {
				font-size: 6px;
				color: #999;
			}
			.item-title {
				width: 100%;
				font-size: 7px;
				line-height: 8px;
				margin-bottom: 3px;
				.item-title-sub {
					display: inline-block;
					width: 140px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				.item-incon {
					font-weight: 500;
					color: #999;
					font-size: 7px;
				}
			}
			.item-subtitle {
				font-weight: 400 !important;
				text-align: left;
				font-size: 6px;
				color: #999999;
				line-height: 7px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
		// .item-content::after {
		// 	content: '';
		// 	position: absolute;
		// 	bottom: 0;
		// 	width: 100%;
		// 	height: 1px;
		// 	background-color: #e5e5e5;
		// }
	}
}
</style>